export const environment = () => {
  const environments = {
    localhost: 'development',
    'd4l-website-dev': 'development',
    'd4l-website-staging': 'development',
    'd4l-website-preview': 'development',
    'd4l-website-cms': 'staging',
    www: 'production',
  };

  return environments[document.location.hostname.split('.').shift()] || environments.production;
};
